import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
	ITEM: '[data-fragment="DynamicLoadedContentComponent.item"]',
	LIST_ITEM: '[data-fragment="DynamicLoadedContentComponent.listItem"]',
};

class DynamicLoadedContentComponent extends WebComponent {
	constructor(props) {
		super(props);
		const {
			time = 300,
		} = props;
		this.state = {
			time,
		};
	}
	didMount() {
		this.itemElement = this.element.querySelectorAll(fragments.ITEM);
		window.addEventListener('scroll', () => {
			 this.checkElementInViewportAndSetClass(this.itemElement, this.state.time);
		}, false);
		 this.checkElementInViewportAndSetClass(this.itemElement, 0);

	}

	checkElementInViewportAndSetClass = (el ,time) => {
		for(var i = 0; i < el.length; i++) {
			if(this.isElementInViewport(el[i]) === true) {
				let element = el[i];
				this.listItemElement = element.querySelectorAll(fragments.LIST_ITEM);
				this.checkListElementInViewportAndSetClass(this.listItemElement);
				window.setTimeout(function() {
					classNames(element, {
						'show-and-move-up': true,
					});

				}, time);
			}
		}
	}

	checkListElementInViewportAndSetClass = (el) => {
		if(el.length > 0) {
			var time = this.state.time;
			if(el.length > 5) {
				time = 150;
			}
			if(this.isElementInViewport(el[0]) === true) {
				for(var i = 0; i < el.length; i++) {
					let element = el[i];
					window.setTimeout(function() {
						classNames(element, {
							'show-and-move-up': true
						});
					}, i * time);
				}
			}
		};
	}


	isElementInViewport = (el) => {
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;

		while(el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}
		return (
				top < (window.pageYOffset + window.innerHeight) &&
				left < (window.pageXOffset + window.innerWidth) &&
				(top + height) > window.pageYOffset &&
				(left + width) > window.pageXOffset
		);
	}

	willUnMount() {
		this.itemElement = null;
	}
}

export default DynamicLoadedContentComponent;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/DynamicLoadedContentComponent/DynamicLoadedContentComponent.js